import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const privacyIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 64"><path d="M24 0C15.01 7.643 9.376 8 0 8v30.76C0 51.035 8.541 54.237 24 64c15.459-9.763 24-12.965 24-25.24V8c-9.376 0-15.01-.357-24-8M5.333 38.76V32H24V6.784c6.667 4.813 12.144 6.112 18.667 6.443V32H24v25.715C9.84 48.973 5.333 46.875 5.333 38.76"/></svg>`
);
